import {getParams} from "../lib/params";
import {getCleanLocalPath} from "../lib/urlPaths";
import {readCachedLocalStorage} from "./cachedLocalStorage";
import {omit} from "lodash";

const STORAGE_KEY = "sessionFacts";

const CACHE = {};

export function getSessionFacts() {
  // memoize it
  return (CACHE[STORAGE_KEY] ||= loadSessionFacts());
}

function loadSessionFacts() {
  const params = getParams();
  let facts = params['RESET'] ? newSessionFacts({params}) :
    (readSessionFactsFromStorage() || newSessionFacts({params}));

  // now mix in data from current session
  updateSessionFacts({facts, params});

  // write to local storage
  writeSessionFactsToStorage(facts);

  // after writing, add the current params and path as a convenience to the PageTriggers module
  facts.currentParams = params;

  return facts;
}

/**
 * Called by getSessionFacts on every page load, this modifies the object
 * to increment page count, put in current path, etc.
 *
 * @param facts
 * @returns {*}
 */
function updateSessionFacts({facts}) {
  const now = new Date().getTime();

  // Not the first page? add in some stuff about session age and previous paths.
  if (facts.pageCount) {
    facts.ageSeconds = (now - (facts.startedAt || now)) / 1000;

    facts.previousPath = facts.urlPath;
    facts.previousPageLoadedAt = facts.pageLoadedAt;
  }

  facts.pageCount = 1 + +(facts.pageCount || 0);
  // alert(`update page count to ${facts.pageCount}`)
  facts.urlPath = getCleanLocalPath();
  facts.pageLoadedAt = now;  // timestamp millis
  // try to do this every time as redux may have not yet been initialized when we first set this up
  facts.remoteAddr ||= readIpAddrFromRedux();
  return facts;
}

function readIpAddrFromRedux() {
  try {
    let store = getReduxStore();
    let state = store?.getState ? store.getState() : {};
    return _.get(state, 'scrapyardSlice.clientIp')
  } catch (err) {
    console.log(`readIpAddrFromRedux: ${err}`);
    return null;
  }
}

function readSessionFactsFromStorage() {
  return readCachedLocalStorage(STORAGE_KEY, {defaultValue: null});
}

// also used by debugPageTriggers so it can reset first page params
export function writeSessionFactsToStorage(data) {
  data = omit(data, 'currentParams'); // currentParams is never writ to storage

  return writeCachedLocalStorage(STORAGE_KEY, data, {
    expiresIn: 4 * 3600
  });
}


function newSessionFacts({params} = {}) {
  return {
    //today: dayjs().format("YYYY-MM-DD"),
    pageCount: 0,  // IMPORTANT! Must be zero to signify this is a new sessionFacts
    startPath: getCleanLocalPath(),
    startedAt: new Date().getTime(),
    ageSeconds: 0,
    firstPageParams: params || getParams(),
    // wikipedia says REFERRER (with double-R amidships) is correct spelling!
    firstPageReferrer: document.referrer
  };
}


export function calculateMillisOnPage({sessionFacts, now}) {
  sessionFacts ||= getSessionFacts();

  return calculateMillisFrom({
    now, timestamp: sessionFacts.pageLoadedAt});
}

export function calculateMillisOnSite({sessionFacts, now}) {
  sessionFacts ||= getSessionFacts();

  return calculateMillisFrom({
    now, timestamp: sessionFacts.startedAt});
}


function calculateMillisFrom({now, timestamp}) {
  if (! now?.getTime) {
    now = new Date();
  }

  if ( isNaN(timestamp)) {
    console.warn('calculateMillisFrom: no timestamp provided');
    return 0;
  }

  const diff = now.getTime() - timestamp;
  return isNaN(diff) ? 0 : diff;
}
